import { Button } from '../_misc/buttons/Button';

import Bars3Icon from '@heroicons/react/20/solid/Bars3Icon';
import { NAVIGATION } from './constants';
import { NavLink } from './NavLink';
import { Dispatch, SetStateAction } from 'react';
import { ButtonType } from '../_misc/buttons/ButtonType';
import classNames from 'classnames';
import { useAuth } from '../../context/auth/useAuth';
import { getUserHomePageUrl } from '../user/user.constants';

export const NavbarLinks = (props: Props) => {
  const { currentUser } = useAuth();
  const { setMobileMenuOpen, isVibrant, isNavbarButtonsDisabled } = props;

  return (
    <>
      <div className="hidden md:flex md:gap-x-6 lg:gap-x-10">
        {NAVIGATION(currentUser ? getUserHomePageUrl(currentUser) : undefined).map((item) => (
          <NavLink key={item.to} to={item.to} isVibrant={isVibrant} isDisabled={isNavbarButtonsDisabled}>
            <span className="font-semibold tracking-wider">{item.name.toLocaleUpperCase()}</span>
          </NavLink>
        ))}
      </div>
      <div className="flex md:hidden">
        <Button
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          buttonType={isVibrant ? ButtonType.LinkLight : ButtonType.PrimaryLink}
          className="sm:-ml-2.5"
        >
          <span className="sr-only">Open main menu</span>
          <Bars3Icon className={classNames('h-10 w-10')} aria-hidden="true" />
        </Button>
      </div>
    </>
  );
};

type Props = {
  setMobileMenuOpen: Dispatch<SetStateAction<boolean>>;
  isVibrant?: boolean;
  isNavbarButtonsDisabled?: boolean;
};
